import React, { useState, useRef, useEffect } from "react";
import "../styles/components/faq.css";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const answerRefs = useRef([]);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    if (answerRefs.current[activeIndex]) {
      answerRefs.current[activeIndex].style.maxHeight =
        answerRefs.current[activeIndex].scrollHeight + "px";
    }
    answerRefs.current.forEach((ref, idx) => {
      if (idx !== activeIndex && ref) {
        ref.style.maxHeight = "0";
      }
    });
  }, [activeIndex]);

  const faqs = [
    {
      question: "Hva er server- side sporing?",
      answer:
        "Server-side sporing er en metode for å samle inn og sende data om brukeratferd via en egen server i stedet for direkte fra brukerens nettleser. Dette gir økt kontroll over datainnsamlingen, bedre personvern, og reduserer risikoen for at data blokkeres av nettleserrestriksjoner, annonseblokkerere eller tredjeparts cookies.",
    },
    {
      question: "Hvor mange foresplørseler trenger jeg?",
      answer:
        "Det kommer an på hvor mange unike besøkende du har på nettsiden din. En tommelfingerregel er at du trenger 1 forespørsel per unike besøkende per måned.",
    },
    {
      question: "Hva om jeg når grensen for forespørseler?",
      answer:
        "Sporingen vil fortsatt fungere etter maksgrensen din er nådd. Hvis du overstiger grensen din betraktelig over en lengre periode, vil vi kontakte deg for å oppgradere pakken din. Du trenger ikke å være redd for å miste viktig data!",
    },
    {
      question: "Hva om jeg har flere domener?",
      answer:
        "Vi anbefaler èn server per domene, eller du kan bruke en server for flere domener. Du kan enkelt sette opp flere domener i serveren din.",
    },

    {
      question: "Hvor lang tid tar det å sette opp?",
      answer:
        "Server- side sporingen kan settes opp på under 5 minutter. Du kan følge vår enkle veiledning når du setter opp serveren din.",
    },
  ];

  return (
    <div className="faq-container">
      {faqs.map((faq, index) => (
        <div
          key={index}
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
          onClick={() => toggleAccordion(index)}
        >
          <div className="faq-question">{faq.question}</div>
          <div
            className="faq-answer"
            ref={(el) => (answerRefs.current[index] = el)}
          >
            {faq.answer}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQ;
